import { ADYEN_PAYMENT_METHODS_REQUEST, ADYEN_PAYMENT_METHODS_SUCCESS, ADYEN_PAYMENT_METHODS_ERROR, ADYEN_PAYMENT_METHODS_RESET, SUBMIT_ADYEN_PAYMENT_REQUEST, SUBMIT_ADYEN_PAYMENT_SUCCESS, SUBMIT_ADYEN_PAYMENT_ERROR, SUBMIT_ADYEN_PAYMENT_RESET, SUBMIT_ADDITIONAL_ADYEN_PAYMENT_REQUEST, SUBMIT_ADDITIONAL_ADYEN_PAYMENT_SUCCESS, SUBMIT_ADDITIONAL_ADYEN_PAYMENT_ERROR, SUBMIT_ADDITIONAL_ADYEN_PAYMENT_RESET, REMOVE_ADYEN_STORED_PAYMENT_REQUEST, REMOVE_ADYEN_STORED_PAYMENT_RESET, REMOVE_ADYEN_STORED_PAYMENT_SUCCESS, REMOVE_ADYEN_STORED_PAYMENT_ERROR, } from '../../constants';
const initialState = {
    adyenPaymentMethods: {
        adyenPaymentMethodsLoading: false,
        adyenPaymentMethodsResponse: null,
        adyenPaymentMethodsError: null,
    },
    submitAdyenPayment: {
        submitAdyenPaymentLoading: false,
        submitAdyenPaymentResponse: null,
        submitAdyenPaymentError: null,
    },
    submitAdditionalAdyenPayment: {
        submitAdditionalAdyenPaymentLoading: false,
        submitAdditionalAdyenPaymentResponse: null,
        submitAdditionalAdyenPaymentError: null,
    },
    removeStoredAdeynPayment: {
        removeStoredAdeynPaymentLoading: false,
        removeStoredAdeynPaymentResponse: null,
        removeStoredAdeynPaymentError: null,
    },
};
const adyenPaymentReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case ADYEN_PAYMENT_METHODS_REQUEST:
            return {
                ...state.adyenPaymentMethods,
                adyenPaymentMethodsLoading: true,
            };
        case ADYEN_PAYMENT_METHODS_SUCCESS:
            return {
                ...state.adyenPaymentMethods,
                adyenPaymentMethodsLoading: false,
                adyenPaymentMethodsResponse: action.response,
                adyenPaymentMethodsError: null,
            };
        case ADYEN_PAYMENT_METHODS_ERROR:
            return {
                ...state.adyenPaymentMethods,
                adyenPaymentMethodsLoading: false,
                adyenPaymentMethodsError: action.response,
                adyenPaymentMethodsResponse: null,
            };
        case ADYEN_PAYMENT_METHODS_RESET:
            return {
                ...initialState.adyenPaymentMethods,
            };
        case SUBMIT_ADYEN_PAYMENT_REQUEST:
            return {
                ...state.submitAdyenPayment,
                submitAdyenPaymentLoading: true,
            };
        case SUBMIT_ADYEN_PAYMENT_SUCCESS:
            return {
                ...state.submitAdyenPayment,
                submitAdyenPaymentLoading: false,
                submitAdyenPaymentResponse: action.response,
                submitAdyenPaymentError: null,
            };
        case SUBMIT_ADYEN_PAYMENT_ERROR:
            return {
                ...state.submitAdyenPayment,
                submitAdyenPaymentLoading: false,
                submitAdyenPaymentError: action.response,
                submitAdyenPaymentResponse: null,
            };
        case SUBMIT_ADYEN_PAYMENT_RESET:
            return {
                ...initialState.submitAdyenPayment,
            };
        case SUBMIT_ADDITIONAL_ADYEN_PAYMENT_REQUEST:
            return {
                ...state.submitAdditionalAdyenPayment,
                submitAdditionalAdyenPaymentLoading: true,
            };
        case SUBMIT_ADDITIONAL_ADYEN_PAYMENT_SUCCESS:
            return {
                ...state.submitAdditionalAdyenPayment,
                submitAdditionalAdyenPaymentLoading: false,
                submitAdditionalAdyenPaymentResponse: action.response,
                submitAdditionalAdyenPaymentError: null,
            };
        case SUBMIT_ADDITIONAL_ADYEN_PAYMENT_ERROR:
            return {
                ...state.submitAdditionalAdyenPayment,
                submitAdditionalAdyenPaymentLoading: false,
                submitAdditionalAdyenPaymentError: action.response,
                submitAdditionalAdyenPaymentResponse: null,
            };
        case SUBMIT_ADDITIONAL_ADYEN_PAYMENT_RESET:
            return {
                ...initialState.submitAdditionalAdyenPayment,
            };
        case REMOVE_ADYEN_STORED_PAYMENT_REQUEST:
            return {
                ...state.removeStoredAdeynPayment,
                removeStoredAdeynPaymentLoading: true,
            };
        case REMOVE_ADYEN_STORED_PAYMENT_SUCCESS:
            return {
                ...state.removeStoredAdeynPayment,
                removeStoredAdeynPaymentLoading: false,
                removeStoredAdeynPaymentResponse: action.response,
                removeStoredAdeynPaymentError: null,
            };
        case REMOVE_ADYEN_STORED_PAYMENT_ERROR:
            return {
                ...state.removeStoredAdeynPayment,
                removeStoredAdeynPaymentLoading: false,
                removeStoredAdeynPaymentError: action.response,
                removeStoredAdeynPaymentResponse: null,
            };
        case REMOVE_ADYEN_STORED_PAYMENT_RESET:
            return {
                ...initialState.removeStoredAdeynPayment,
            };
        default:
            return state;
    }
};
export default adyenPaymentReducer;
